import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import throttle from "lodash/throttle";
import { object, string, func, boolean } from "prop-types";
import { SocialShare, Link } from "@quintype/components";

import translate from "../../translate";

import { SectionIcon } from "../../basic/icons/section-icon";
import { NewsPaperIcon } from "../../basic/icons/news-paper-icon";
import { NewsLetterIcon } from "../../basic/icons/news-letter-icon";
import { ShareIcon } from "../../basic/icons/share-icon";
import { ContributeIcon } from "../../basic/icons/contribute-icon";
import { Facebook } from "../../basic/icons/facebook";
import { Twitter } from "../../basic/icons/twitter";
import { Whatsapp } from "../../basic/icons/whatsapp";
import RightArrow from "../../basic/right-arrow";

import { loadNextStories, bottomStickyTopStory } from "../../utils/api";

import "./bottom-sticky.m.css";

const socialShareIcons = ({ twitterUrl, fbUrl, whatsappUrl }) => {
  return (
    <ul>
      <li styleName="social-share-icon">
        <a styleName="social-share-link facebook-bg" href={fbUrl} target="_blank" rel="noopener noreferrer">
          <Facebook color="#fff" />
        </a>
      </li>
      <li styleName="social-share-icon">
        <a styleName="social-share-link twitter-bg" href={twitterUrl} target="_blank" rel="noopener noreferrer">
          <Twitter color="#fff" />
        </a>
      </li>
      <li styleName="social-share-icon">
        <a styleName="social-share-link whatsapp-bg" href={whatsappUrl} target="_blank" rel="noopener noreferrer">
          <Whatsapp color="#fff" />
        </a>
      </li>
    </ul>
  );
};

socialShareIcons.propTypes = {
  twitterUrl: string,
  fbUrl: string,
  whatsappUrl: string
};

const BottomSticky = ({ next, story = {}, navigateToPage, lang, collection }) => {
  const [nextStory, setNextStory] = useState([]);
  const [showShare, setShowShare] = useState(false);
  const [topStory, setTopStory] = useState({});
  const [showTopStoryBox, setShowTopStoryBox] = useState(false);
  const [topStoryBoxEnabled, setTopStoryBoxEnabled] = useState(true);

  useEffect(() => {
    loadNextStories(1).then(items => {
      const storyId = localStorage.getItem("storyId");
      let findNextSory = items[0].id === story.id ? items[1] : items[0];
      if (storyId) {
        const oldIndex = items.findIndex(i => i.id === storyId);
        const nextStory = items[oldIndex + 1];
        findNextSory = nextStory && nextStory.id !== story.id ? nextStory : items[0];
      }
      setNextStory(findNextSory || items[0]);
    });
  }, []);

  useEffect(() => {
    bottomStickyTopStory()
      .then(story => {
        setTopStory(story);
      })
      .catch(error => {
        console.log("error :>> ", error);
      });
  }, []);

  useEffect(() => {
    window.addEventListener("scroll", throttle(handleScroll, 100));
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    let currentScrollPos = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScrollPos >= 250) {
      setShowTopStoryBox(true);
    } else {
      setShowTopStoryBox(false);
    }
  };

  const setStoryId = () => {
    if (nextStory.slug) {
      localStorage.setItem("storyId", nextStory.id);
      navigateToPage(`/${nextStory.slug}`);
    } else {
      console.log("next story not found");
    }
  };

  const onShareClick = () => {
    setShowShare(!showShare);
  };

  const onCloseBtnClick = () => {
    setTopStoryBoxEnabled(false);
  };

  const epaperLink = lang => {
    if (lang === "hi") {
      return "http://epaper.navjivanindia.com/";
    } else {
      return "http://epaper.nationalheraldindia.com";
    }
  };

  return (
    <React.Fragment>
      <div styleName="wrapper">
        <Link styleName="link" href="/section/opinion">
          <SectionIcon />
          <span>{translate(lang, "opinion_articles")}</span>
        </Link>
        {!next && (
          <Link styleName="link" href={epaperLink(lang)}>
            <NewsPaperIcon />
            <span>{translate(lang, "e_paper")}</span>
          </Link>
        )}
        {/* Commented out until the Newsletter feature started */}
        <Link styleName="link" href={next ? "/subscribe" : "/newsletter"}>
          {next ? <ContributeIcon /> : <NewsLetterIcon />}
          <span>{next ? translate(lang, "subscribe_newspaper") : translate(lang, "newsletters")}</span>
        </Link>
        <Link styleName={!next ? "link" : "no-link"} href="/subscribe">
          <ContributeIcon />
          <span>{translate(lang, "subscribe_newspaper")}</span>
        </Link>
        <div styleName={next ? "link" : "no-link"}>
          <ShareIcon color="#fff" width="24" height="24" />
          <span onClick={onShareClick}>
            <span>{translate(lang, "share")}</span>
          </span>
        </div>

        <div
          style={{ display: next ? "" : "none" }}
          onClick={setStoryId}
          styleName={`next-button ${lang === "ur" ? "urdu-text" : ""}`}
        >
          <span styleName="text">next</span>
          <RightArrow />
        </div>
      </div>
      <div styleName={next && showShare ? `social-share-wrapper ${lang}` : "no-link"}>
        <SocialShare template={socialShareIcons} title={story.headline} url={story.slug} color="#fff" />
      </div>
      {topStoryBoxEnabled && (
        <div styleName={showTopStoryBox ? "top-story-box" : "no-link"}>
          <span onClick={onCloseBtnClick} styleName="close-btn">
            x
          </span>
          <Link href={topStory.slug} styleName="top-story-box-link">
            <img
              styleName="top-story-box-img"
              src={`https://gumlet.assettype.com/${topStory["hero-image-s3-key"]}`}
              alt={topStory["hero-image-caption"]}
            />
            <span styleName="top-story-box-headline">{topStory.headline}</span>
          </Link>
        </div>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  lang: get(state, ["qt", "config", "publisher-attributes", "lang"], "en")
});

const mapDispatchToProps = dispatch => ({
  navigateToPage: url => global.app.navigateToPage(dispatch, url)
});

BottomSticky.propTypes = {
  story: object,
  collection: object,
  navigateToPage: func,
  lang: string,
  next: boolean,
  topStoryBox: boolean
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BottomSticky);
